import { render } from "./ProsesSatker.vue?vue&type=template&id=2cd7d199"
import script from "./ProsesSatker.vue?vue&type=script&lang=js"
export * from "./ProsesSatker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__